import * as React from "react";
import { ComplianceStatus, ViolationType } from "../../../../../types/dispute";

interface Props {
  status: ComplianceStatus;
  type: ViolationType;
  reasonDefault?: string;
}

export const RatesStatus: React.FC<Props> = ({ status, type, reasonDefault }) => {
  let nonComplianceReason = reasonDefault;
  switch (type) {
    case ViolationType.RatesMissing:
      nonComplianceReason = "Rate missing";
      break;
    case ViolationType.ContractRatesMismatch:
    case ViolationType.StandardRatesMismatch:
      nonComplianceReason = "Rates mismatch";
      break;
    default:
      break;
  }

  let label: React.ReactNode = null;
  switch (status) {
    case ComplianceStatus.Skipped:
      label = <h4 className="text-text-subdued">Validation Skipped</h4>;
      break;
    case ComplianceStatus.Compliant:
      label = <h4 className="text-text-informative-success">Rates Matched</h4>;
      break;
    case ComplianceStatus.NonCompliant:
      if (nonComplianceReason) {
        label = <h4 className="text-text-informative-warning">{nonComplianceReason}</h4>;
      }
      break;
    default:
      break;
  }

  if (!label) {
    return null;
  }

  return <div className="font-medium flex justify-end text-right">{label}</div>;
};
RatesStatus.displayName = "OSRA.Rates.RatesStatus";
